<template>
  <div>
    <section class="pb-2">
      <b-col class="d-flex justify-content-start col-3 px-0 pt-50">
        <b-form-group
          class="w-100 mb-1"
        >
          <b-skeleton
            v-if="isLoading"
            animation="wave"
            type="input"
          />
          <v-select
            v-else
            v-model="selectedAdType"
            :clearable="false"
            label="text"
            :placeholder="$tk('ClientPortal.Multipliers.ChooseAdType')"
            :options="correctAdTypes(adTypes)"
            :reduce="adType => adType.value"
            @option:selected="adTypeChange"
          />
        </b-form-group>
      </b-col>
      <b-card
        class="my-50"
        no-body
      >
        <Table
          :data="multipliers"
          :columns="scoringMultipliersColumns"
          :is-loading="isLoading"
          type-of-table="multipliers"
          :enable-pagination="false"
          :enable-sort="false"
        />
      </b-card>
      <hr class="mx-50 my-2">
      <div class="d-flex justify-content-end px-50">
        <b-button
          variant="primary"
          :disabled="isLoading"
          size="sm"
          @click="save"
        >
          {{ $tk('ClientPortal.Admin.SaveChanges') }}
        </b-button>
      </div>
    </section>
  </div>
</template>

<script>
import { VBModal } from 'bootstrap-vue'
import {
  ref,
  computed,
  onMounted,
} from '@vue/composition-api'
import Table from '@/components/Table.vue'
import notification from '@/mixins/toastification'
import ScoringService from '@/api/admin/scoring.service'
import translation from '@/mixins/translate'
import store from '@/store'
import vSelect from 'vue-select'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    // Bootstrap Components
    Table,
    vSelect,
  },
  mixins: [notification],
  setup() {
    const scoringMultipliersColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.ScoringMultipliers.Title'),
        field: 'title',
        width: '50%',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.ScoringMultipliers.Value'),
        field: 'value',
        width: '50%',
      },
    ]
    const isLoading = ref(false)
    const multipliers = computed(() => store.getters.getMultipliers)
    const adTypes = ref([])
    const selectedAdType = ref(1)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getScoreMultipliers')
      adTypes.value = multipliers.value.adTypes
      selectedAdType.value = multipliers.value.selectedAdType
      isLoading.value = false
    })
    const adTypeChange = async () => {
      await store.dispatch('getScoreMultipliers', selectedAdType.value)
    }

    const save = async () => {
      try {
        const response = await ScoringService.updateScoreMultiplier({ ...multipliers.value, multipliers: multipliers.value.rows })
        if (response) {
          notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(translation.methods.$tk('ClientPortal.Admin.ErrorSavingChanges'))
        }
      } catch (err) {
        notification.methods.error(err.message)
      }
    }

    const correctAdTypes = types => Object.keys(types).map(k => ({ text: types[k], value: parseInt(k, 10) }))

    return {
      isLoading,
      multipliers,
      adTypes,
      selectedAdType,
      adTypeChange,
      save,
      scoringMultipliersColumns,
      correctAdTypes,
    }
  },
}
</script>
